module.exports = __webpack_public_path__ + "static/media/ava13.b4a0ca37.png";